export default "__VITE_ASSET__0ScKCuXH__"